import React from 'react';
import MonthSelect from '../../../atoms/MonthSelect';
import GroupSelect, { GroupItem } from '~react/components/Calendar/components/GroupSelect';
import { BasicObject } from '~components/ObjectHelper';

interface FilterCell {
    defaultValue: string;
    label: string;
    name: string;
    options: BasicObject[];
    type: 'text' | 'select' | 'date' | 'checkbox' | 'months';
}

interface FilterProps {
    cells: FilterCell[];
    values: { [key: string]: string };
    onChange: (name: string, value: string) => void;
}

const Filter: React.FC<FilterProps> = props => {
    const cells = props.cells.map(cell => {
        switch (cell.type) {
            case 'months':
                return (
                    <MonthSelect
                        key={cell.name}
                        onChange={date => {
                            props.onChange(cell.name, date);
                        }}
                        value={'' === props.values[cell.name] ? new Date() : new Date(props.values[cell.name])}
                        id={cell.name}
                        label={cell.label}
                        startDate={0 === cell.options.length ? new Date() : new Date(Date.parse(cell.options[0].from))}
                        endDate={0 === cell.options.length ? new Date() : new Date(Date.parse(cell.options[0].to))}
                    />
                );
            case 'select':
                return (
                    <GroupSelect
                        key={cell.name}
                        value={props.values[cell.name]}
                        setGroup={value => {
                            props.onChange(cell.name, value);
                        }}
                        label={cell.label}
                        show={true}
                        data={cell.options as GroupItem[]}
                        id={cell.name}
                    />
                );
        }
    });
    return <div className="filter -rounded">{cells}</div>;
};

export default Filter;
export { FilterCell };
